export default __webpack_public_path__ + "static/media/generator-capacity-icon.d0607be0.svg";